import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { getFormValues, change } from "redux-form";
import { Icon } from "rhombus-react";
import classNames from "classnames";

import { SOCIAL_WIZARD } from "widgets/forms/list";
import { PAC_FORM_TYPES, PAC_FORM_TYPES_LIST } from "social/constants";
import { getPlacementErrorByAdType } from "selectors/Social2";
import { SOCIAL_AD_TYPE_LIST } from "utils/constants";

export default function PlacementTag({
	pacType,
	adType,
	canRemove,
	showPristineErrors,
	setActivePlacement,
}) {
	const dispatch = useDispatch();
	const {
		 _currentActivePAC,
		isNew,
	} = useSelector((state) => {
		const { _currentActivePAC, placements } = getFormValues(SOCIAL_WIZARD)(state)?.[adType] || {};

		return {
			_currentActivePAC,
			isNew: placements?.[pacType]?._isNew,
		};
	});
	const { hasError } = useSelector(getPlacementErrorByAdType(adType, pacType, !isNew && showPristineErrors));
	const isActive = _currentActivePAC === pacType;

	function handleChange() {
		dispatch(setActivePlacement(pacType));
	}

	function handleRemove() {
		dispatch(change(SOCIAL_WIZARD, `${adType}.placements.${pacType}.status`, "disabled"));

		if (isActive) {
			dispatch(setActivePlacement(PAC_FORM_TYPES.DEFAULT));
		}
	}

	return (
		<button
			className={classNames("custom-tag c-tag", {
				"is-active": isActive,
				"has-error": hasError,
			})}
		>
			<div className="c-tag-label" title={pacType} onClick={handleChange}>
				{pacType}
			</div>
			{canRemove && (
				<div
					className="c-tag-remove"
					aria-hidden={true}
					title="Remove"
					onClick={handleRemove}
				>
					<Icon name="clear" iconStyle="far" />
				</div>
			)}
		</button>
	);
}

PlacementTag.propTypes = {
	pacType: PropTypes.oneOf(PAC_FORM_TYPES_LIST).isRequired,
	adType: PropTypes.oneOf(SOCIAL_AD_TYPE_LIST).isRequired,
	canRemove: PropTypes.bool,
	showPristineErrors: PropTypes.bool,
	setActivePlacement: PropTypes.func,
};
